var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"noticeBarRef",staticClass:"notice-bar"},[_c('div',{ref:"contentRef",staticClass:"notice-bar-content",style:(_vm.contentStyle)},[_vm._t("default"),(_vm.animateFlag)?[_c('span',{staticClass:"content-headway",style:({ width: `${_vm.headway}px` })}),_vm._t("default")]:_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }